import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { openPricingDialog, setActiveTab } from '../../store/slices/pricingSlice';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Skeleton from '@mui/material/Skeleton';
import { ArrowRight, ArrowLeft } from 'lucide-react';
import ExploreStyles from '../ExploreStyles';
import SavingsIcon from '@mui/icons-material/Savings';
import ControlCameraIcon from '@mui/icons-material/ControlCamera';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';

const exampleInfluncers = [
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-z8r6wb9eexrm40cjxj89njcrk4_2.jpg?generation=1730545763899024&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-pyp23ceatnrm20cjwpfarw86a4_3.jpg?generation=1730429318216779&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-pyp23ceatnrm20cjwpfarw86a4_2.jpg?generation=1730429319435547&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-5yab52zyqhrm00cjwndv9m8hh0_0.jpg?generation=1730424938359692&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-z4sa7vxj0hrm40cjw9ervdv138_2.jpg?generation=1730374717660419&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-82rn2fqd3srm60cjw9ct19sbfr_3.jpg?generation=1730374508361406&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-1bvtpkas5hrm20cjw97b3m75h8_3.jpg?generation=1730373717174617&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-xj0dq8146hrm20cjw7jb6tp494_0.jpg?generation=1730366751685269&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-fajqtp3b01rm20cjvk2rfkgahr_2.jpg?generation=1730280857464762&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-9qnh8ngh09rm40cjvgw8pddmd0_2.jpg?generation=1730271590711341&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-a9mj4cf5xxrm60cjvgkvw9jdkw_0.jpg?generation=1730270528349868&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-nf6kt1ahqnrmc0ck3eyvqjhpym_2.jpg?generation=1731337281164717&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-51v8bny331rme0ck3extd8r4zw_2.jpg?generation=1731337188049181&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-0f9akj1tv9rmc0ck3c2bhcfkq8_2.jpg?generation=1731325355694864&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-ze51jnznqxrmc0ck3c08we6kt8_1.jpg?generation=1731324936323287&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-ze51jnznqxrmc0ck3c08we6kt8_3.jpg?generation=1731324936371616&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-0e324zq9ksrmc0ck3bzbsj69zw_3.jpg?generation=1731324824860188&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-0e324zq9ksrmc0ck3bzbsj69zw_0.jpg?generation=1731324825110355&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-djgb2f58qsrme0ck2tzvje0pqw_3.jpg?generation=1731253556021214&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-yc7cfmqg5srma0ck2tx9kpf6c0_1.jpg?generation=1731253254554879&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-83zyqwwb7nrma0ck0vybstv814_0.jpg?generation=1730989168319819&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-f6hxr8wtzsrmc0ck0tys8xzff8_3.jpg?generation=1730984983366851&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-w479w0d4axrme0ck0txb0zx3cc_3.jpg?generation=1730984792365740&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-j7qaf5nk8drm00cjzahsabzj0c_1.jpg?generation=1730781965354533&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-f9gsxryj8drm40cjz9qa21ncv0_2.jpg?generation=1730778492044292&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-yzyyfnzd49rm20cjz9msf49vmg_3.jpg?generation=1730778288348759&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-1vat5wr9t9rm40cjz9mv7s6hrm_3.jpg?generation=1730778086578487&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-s2za1tm77srm00cjz9kv41tgf4_2.jpg?generation=1730778014018477&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-jgvy91rqhnrm00cjz9kbqs3qwr_3.jpg?generation=1730777928030748&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-y4s96g34fdrm60cjz818hcxn54_3.jpg?generation=1730771386130066&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-etb0f3fd0hrm20cjz7z9mq5zq8_2.jpg?generation=1730771168321892&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-ksdq9mwqnxrm60cjyt6sm4ghgw_3.jpg?generation=1730713400272026&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-q80850a4hnrm20cjyt68z5f4rr_3.jpg?generation=1730713313589843&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-113qtcc571rm40cjyt3br55y68_2.jpg?generation=1730712936814834&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-mq80mmxyjsrm00cjxzq92eazfw_2.jpg?generation=1730602331477746&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-dcgpjazjnxrm20cjxmdsc5hgcw_3.jpg?generation=1730554962925059&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-vw3wmz24r1rm60cjxm7a9qrtk8_3.jpg?generation=1730554065215855&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-ttbegky1q1rm60cjxk0a42azcr_0.jpg?generation=1730548994500285&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-ycsdc88w69rm20cjxjzr2xdqsr_2.jpg?generation=1730548876511086&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-ctpr14vjfsrm60cjxjmt2g1e1r_0.jpg?generation=1730547456029413&alt=media',
    'https://storage.googleapis.com/download/storage/v1/b/reokai.appspot.com/o/files%2Freok-d454stpthxrm60cjxja9dedt70_3.jpg?generation=1730546107232867&alt=media'
];

const StyledCard = styled(Card)(({ theme, darkMode }) => ({
    backgroundColor: darkMode ? '#1E1E1E' : '#FFFFFF',
    borderRadius: '12px',
    cursor: 'pointer',
    transition: 'transform 0.2s ease-in-out',
    '&:hover': {
        transform: 'translateY(-4px)',
    },
}));

const AIInfluencersDialog = ({ open, onClose, darkMode, t, currentLanguage, userData, firebase, isMobile, handleSelectCollection, onShowPricing, openStudio }) => {

    // const dispatch = useDispatch();

    const [currentView, setCurrentView] = useState('main');
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [trendingPacks, setTrendingPacks] = useState([]);
    const [forCreatorPacks, setForCreatorPacks] = useState([]);
    const [forBusinessPacks, setForBusinessPacks] = useState([]);

    const dialogContentsRef = useRef(null);

    useEffect(() => {
        if (open) {
            setCurrentView('main');
        }
    }, [open]);

    // useEffect(() => {
    //     firebase.getPhotoPacksOnLanding().then(querySnapshot => {
    //         const sortedPacks = querySnapshot.docs.map(doc => doc.data()).sort((a, b) => {
    //             return (b.isHot ? 1 : 0) - (a.isHot ? 1 : 0) || (new Date(a.createdAt) - new Date(b.createdAt)); // Sort by isHot and then by createdAt
    //         });
    //         setTrendingPacks(sortedPacks.filter(pack => pack.category.includes('trending')));
    //         setForCreatorPacks(sortedPacks.filter(pack => pack.category.includes('for_creator')));
    //         setForBusinessPacks(sortedPacks.filter(pack => pack.category.includes('for_business')));
    //     });
    // }, []);

    // Add new useEffect for image cycling
    // useEffect(() => {
    //     if (dialogContentsRef.current) {
    //         dialogContentsRef.current.scrollTop = 0;
    //     }

    //     if (currentView === 'howItWorks') {
    //         const interval = setInterval(() => {
    //             setCurrentImageIndex((prevIndex) =>
    //                 prevIndex === exampleInfluncers.length - 1 ? 0 : prevIndex + 1
    //             );
    //         }, 300);

    //         return () => clearInterval(interval);
    //     }

    // }, [currentView]);

    const influencerOptions = [
        {
            title: 'Cost-effective',
            description: 'High-quality content without high fees.',
            icon: <SavingsIcon sx={{ fontSize: 32 }} />,
            onClick: () => {
            },
        },
        {
            title: 'Brand control',
            description: 'Full creative control for a perfectly aligned brand image.',
            icon: <ControlCameraIcon sx={{ fontSize: 32 }} />,
            onClick: () => {
            },
        },
        {
            title: 'Personalized engagement',
            description: 'Well-crafted content tailored to audience needs.',
            icon: <AutoGraphIcon sx={{ fontSize: 32 }} />,
            onClick: () => {
            },
        },
    ];

    const renderContent = () => {

        const getRandomPhotos = (photos, count) => {
            const shuffled = [...photos].sort(() => 0.5 - Math.random());
            return shuffled.slice(0, count);
        };
        
        const randomPhotos = getRandomPhotos(exampleInfluncers, 20);

        if (currentView === 'howItWorks') {
            return (
                <Box sx={{ position: 'relative', pb: 4 }}>
                    {/* Header */}
                    <Box
                        sx={{
                            textAlign: 'center',
                            pt: 3,
                            pb: 1,
                        }}
                    >
                        <Typography
                            variant="h5"
                            component="h2"
                            sx={{
                                fontWeight: 700,
                                color: darkMode ? 'white' : 'black',
                                fontSize: {
                                    xs: '1.25rem', // 20px for mobile
                                    sm: '1.5rem',  // 24px for tablet and up (default h5 size)
                                },
                                lineHeight: {
                                    xs: 1.3,
                                    sm: 1.5,
                                },
                            }}
                        >
                            How it works
                        </Typography>
                    </Box>

                    {/* Back Button */}
                    <IconButton
                        onClick={() => setCurrentView('main')}
                        sx={{
                            position: 'absolute',
                            left: 20,
                            top: 20,
                            color: darkMode ? 'white' : 'black',
                            fontSize: '14px',
                        }}
                    >
                        <ArrowLeft size={isMobile ? 14 : 24} className="mr-1" /> Back
                    </IconButton>

                    {/* Steps Grid */}
                    <div className="flex items-center justify-center px-6 py-6">
                        <div className="pipeline-wrapper w-full max-w-4xl">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 relative">
                                {/* Connecting lines for desktop */}
                                <div className="hidden md:block absolute top-1/2 left-0 w-full h-1 bg-gradient-to-r from-pink-500 to-purple-500 -translate-y-1/2 z-0" />

                                {[
                                    { title: 'Select your appearance', image: 'images/guide-step-1.webp' },
                                    { title: 'Upload 10+ photos of yourself', image: 'images/guide-step-2.webp' },
                                    { title: 'Pay for your headshots package', image: 'images/guide-step-3.webp' },
                                    { title: 'Finally, receive your headshots', images: exampleInfluncers },
                                ].map((step, index) => (
                                    <Box
                                        key={index}
                                        sx={{
                                            position: 'relative',
                                            zIndex: 10,
                                            transform: 'translateZ(0)', // Performance optimization
                                        }}
                                    >
                                        {index + 1 !== 4 && (
                                            <Box
                                                sx={{
                                                    position: 'absolute',
                                                    top: -20,
                                                    left: '50%',
                                                    transform: 'translateX(-50%)',
                                                    zIndex: 2,

                                                    // Size & Shape
                                                    width: 40,
                                                    height: 40,
                                                    borderRadius: '50%',

                                                    // Visual Style
                                                    background: `linear-gradient(135deg, #fc5185 0%, #f78ca0 100%)`,
                                                    boxShadow: '0 4px 20px rgba(252, 81, 133, 0.3)',

                                                    // Content Alignment
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',

                                                    // Text Style
                                                    color: 'white',
                                                    fontWeight: 700,
                                                    fontSize: '1.125rem',

                                                    // Animation
                                                    animation: 'pulse 2s infinite',
                                                    '@keyframes pulse': {
                                                        '0%': {
                                                            boxShadow: '0 0 0 0 rgba(252, 81, 133, 0.4)',
                                                        },
                                                        '70%': {
                                                            boxShadow: '0 0 0 10px rgba(252, 81, 133, 0)',
                                                        },
                                                        '100%': {
                                                            boxShadow: '0 0 0 0 rgba(252, 81, 133, 0)',
                                                        },
                                                    },
                                                }}
                                            >
                                                {index + 1}
                                            </Box>
                                        )}

                                        {/* Step Content Container */}
                                        <Box
                                            sx={{
                                                // Base Style
                                                backgroundColor: darkMode ? '#000' : '#FFFFFF',
                                                backdropFilter: 'blur(10px)',
                                                p: 3.5,
                                                borderRadius: 3,

                                                // Border & Shadow
                                                border: `1px solid ${darkMode ? '#2A2A2A' : '#E0E0E0'}`,
                                                boxShadow: darkMode ? '0 4px 30px rgba(0, 0, 0, 0.3)' : '0 4px 30px rgba(0, 0, 0, 0.1)',

                                                // Hover Effects
                                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                '&:hover': {
                                                    transform: 'translateY(-8px)',
                                                    boxShadow: darkMode ? '0 8px 40px rgba(236, 72, 153, 0.2)' : '0 8px 40px rgba(236, 72, 153, 0.15)',
                                                    borderColor: '#fc5185',
                                                    '& img': {
                                                        transform: 'scale(1.05)',
                                                    },
                                                },
                                            }}
                                        >
                                            <div key={index}>
                                                <div className="flex items-center mb-4">
                                                    <h3 className={`ml-4 text-sm font-semibold ${darkMode ? 'text-white' : 'text-gray-800'}`}>{step.title}</h3>
                                                </div>
                                                <div className="relative aspect-video rounded-lg overflow-hidden shadow-lg"
                                                    style={{ height: step.images ? '290px' : '100%' }}> {/* Conditional height */}
                                                    {step.images ? (
                                                        <div className="image-cycle-container h-full">
                                                            <img
                                                                src={step.images[currentImageIndex]}
                                                                alt={`${step.title} result`}
                                                                className="w-full h-full object-cover"
                                                                style={{
                                                                    borderRadius: '10px',
                                                                    transition: 'opacity 0.2s ease-in-out',
                                                                    objectPosition: 'center', // Center the image
                                                                    objectFit: 'cover',      // Maintain aspect ratio while covering container
                                                                    display: 'block',        // Remove any default spacing
                                                                    margin: '0 auto'         // Center horizontally
                                                                }}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <img
                                                            src={step.image}
                                                            alt={step.title}
                                                            className="w-full h-full object-cover"
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </Box>
                                    </Box>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Start Button */}
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <button
                            onClick={() => setCurrentView('main')}
                            className={`px-8 py-3 rounded-full font-semibold bg-pink-500 text-white hover:bg-pink-600 transition-colors`}
                        >
                            I got it →
                        </button>
                    </Box>
                </Box>
            );
        }

        if (currentView === 'viewStyles') {
            return (
                <Box sx={{ position: 'relative', pb: 4 }}>
                    {/* Header */}
                    <Box
                        sx={{
                            textAlign: 'center',
                            pt: 3,
                            pb: 1,
                        }}
                    >
                        <Typography
                            variant="h5"
                            component="h2"
                            sx={{
                                fontWeight: 700,
                                color: darkMode ? 'white' : 'black',
                                fontSize: {
                                    xs: '1.25rem', // 20px for mobile
                                    sm: '1.5rem',  // 24px for tablet and up (default h5 size)
                                },
                                lineHeight: {
                                    xs: 1.3,
                                    sm: 1.5,
                                },
                            }}
                        >
                            Select Style
                        </Typography>
                    </Box>

                    {/* Back Button */}
                    <IconButton
                        onClick={() => setCurrentView('main')}
                        sx={{
                            position: 'absolute',
                            left: 20,
                            top: 20,
                            color: darkMode ? 'white' : 'black',
                            fontSize: '14px',
                        }}
                    >
                        <ArrowLeft size={isMobile ? 14 : 24} className="mr-1" /> Back
                    </IconButton>

                    <div className="px-5">
                        <ExploreStyles
                            firebase={firebase}
                            stylesList={[]}
                            promptStyle={''}
                            darkMode={darkMode}
                            trendingPacks={trendingPacks}
                            forCreatorPacks={forCreatorPacks}
                            forBusinessPacks={forBusinessPacks}
                            handleSelectCollection={handleSelectCollection}
                        />
                    </div>
                </Box>
            );
        }

        // Return main content
        return (
            <Box sx={{ position: 'relative' }}>
                <Box
                    sx={{
                        width: '100%',
                        height: 280,
                        display: 'flex',
                        position: 'relative',
                        backgroundColor: '#000',
                        overflow: 'hidden',
                        willChange: 'transform',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 2,
                            animation: 'slideImages 80s linear infinite',
                            willChange: 'transform',
                            transform: 'translate3d(0, 0, 0)',
                            backfaceVisibility: 'hidden',
                            '@keyframes slideImages': {
                                '0%': {
                                    transform: `translate3d(calc(-280px * ${randomPhotos.length}), 0, 0)`,
                                },
                                '100%': {
                                    transform: 'translate3d(0, 0, 0)',
                                },
                            },
                            '&:hover': {
                                animationPlayState: 'paused',
                            },
                        }}
                    >
                        {[...randomPhotos, ...randomPhotos, ...randomPhotos].map((image, index) => (
                            <Box
                                key={index}
                                sx={{
                                    position: 'relative',
                                    width: '180px',
                                    // height: '280px',
                                    flexShrink: 0,
                                }}
                            >
                                {/* <Skeleton
                                    variant="rectangular"
                                    width={280}
                                    height={280}
                                    animation="wave"
                                    sx={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        bgcolor: darkMode ? 'grey.900' : 'grey.200',
                                        display: 'block',
                                    }}
                                /> */}
                                <Box
                                    component="img"
                                    src={image}
                                    loading="lazy"
                                    decoding="async"
                                    // fetchPriority={index < exampleInfluncers.length ? "high" : "low"}
                                    sx={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        borderRadius: '10px',
                                        willChange: 'transform',
                                        transform: 'translate3d(0, 0, 0)',
                                        WebkitFontSmoothing: 'antialiased',
                                        transition: 'transform 0.5s ease',
                                        opacity: 0,
                                        animation: 'fadeIn 0.5s ease forwards',
                                        '@keyframes fadeIn': {
                                            to: { opacity: 1 }
                                        },
                                        '&:hover': {
                                            transform: 'scale(1.05)',
                                        },
                                    }}
                                    // onLoad={(e) => {
                                    //     e.target.style.opacity = '1';
                                    //     const skeleton = e.target.previousSibling;
                                    //     if (skeleton) {
                                    //         skeleton.style.display = 'none';
                                    //     }
                                    // }}
                                />
                            </Box>
                        ))}
                    </Box>
                    {/* <div
                    style={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        height: '100px',
                        width: '100%',
                        background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(28, 29, 33) 100%)',
                        pointerEvents: 'none',
                    }}
                /> */}
                </Box>
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: 'white',
                    }}
                >
                    <CloseIcon />
                </IconButton>

                <Box
                    sx={{
                        textAlign: 'center',
                        pt: 6,
                        pb: 4,
                        px: 3,
                    }}
                >
                    <Typography
                        variant="h5"
                        component="h2"
                        sx={{
                            fontWeight: 700,
                            color: darkMode ? 'white' : 'black',
                            mb: 1,
                        }}
                    >
                        AI Influencers
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            color: darkMode ? '#888888' : '#666666',
                            mb: 4,
                        }}
                    >
                        Generate unique virtual influencers for your ads, social medias, and more
                    </Typography>

                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: {
                                xs: '1fr', // 1 column for mobile
                                sm: 'repeat(2, 1fr)', // 2 columns for tablets
                                md: 'repeat(3, 1fr)', // 3 columns for desktop
                            },
                            gap: { xs: 2, sm: 2, md: 2 },
                            px: { xs: 1, sm: 2 }, // Reduce padding on mobile
                            mb: 4,
                        }}
                    >
                        {influencerOptions.map((option, index) => (
                            <StyledCard
                                key={index}
                                onClick={option.onClick}
                                sx={{
                                    bgcolor: darkMode ? '#2A2A2A' : '#F8F9FA',
                                    p: 3,
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease-in-out',
                                    border: 'none',
                                    boxShadow: 'none',
                                    '&:hover': {
                                        transform: 'translateY(-4px)',
                                        bgcolor: darkMode ? '#333333' : '#F0F0F0',
                                    },
                                    '&::before': {
                                        content: '""',
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '4px',
                                        background: 'linear-gradient(115deg, #4fcf70, #fad648, #a767e5, #12bcfe, #44ce7b);',
                                        opacity: 0,
                                        transition: 'opacity 0.3s ease',
                                    },
                                    '&:hover::before': {
                                        opacity: 1,
                                    },
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: 1,
                                }}
                            >
                                <Box
                                    sx={{
                                        color: darkMode ? 'white' : 'black',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        mb: 1,
                                    }}
                                >
                                    {option.icon}
                                </Box>
                                <Typography
                                    variant="subtitle1"
                                    sx={{
                                        fontWeight: 600,
                                        color: darkMode ? 'white' : 'black',
                                        textAlign: 'center',
                                    }}
                                >
                                    {option.title}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: darkMode ? '#888888' : '#666666',
                                        textAlign: 'center',
                                        fontSize: '0.875rem',
                                    }}
                                >
                                    {option.description}
                                </Typography>
                            </StyledCard>
                        ))}
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <button
                            onClick={() => openStudio()}
                            className={`px-6 py-3 rounded-full font-semibold bg-pink-500 text-white hover:bg-pink-600`}>
                            Go to studio →
                        </button>
                    </Box>
                </Box>
            </Box>
        );
    };

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                maxWidth="md"
                fullWidth
                BackdropProps={{
                    sx: {
                        backdropFilter: 'blur(8px)',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    },
                }}
                PaperProps={{
                    sx: {
                        borderRadius: '12px',
                        bgcolor: darkMode ? '#000' : '#FFFFFF',
                        backgroundImage: 'none',
                        border: darkMode ? '1px solid #2A2A2A' : '1px solid #E0E0E0 ',
                        margin: { xs: 2, sm: 3 }, // Add margin on small screens
                    },
                }}
            >
                <DialogContent ref={dialogContentsRef} sx={{ p: 0 }}>{renderContent()}</DialogContent>
            </Dialog>
        </>
    );
};

export default AIInfluencersDialog;